import {ADICIONAR_PESSOA_CORRETOR, REMOVER_PESSOA_CORRETOR, CARREGAR_CORRETORES_SERVER, EDITAR_INFORMACOES_CORRETOR} from '../constants/constants'
import {database} from '../firebase'
import {doLoad, finishLoad} from '../actions/request'
import {carregarCorretoresNaStore} from '../actions/corretores'

export default ({dispatch}) => next => action =>{

    if(action.type == CARREGAR_CORRETORES_SERVER){
        dispatch(doLoad())
        database.ref('/usuarios/').on('value', (snap)=>{
            dispatch(finishLoad())
            dispatch(carregarCorretoresNaStore(snap.val()));
            console.log('if(action.type == CARREGAR_CORRETORES_SERVER){', snap.val())
        })
    }

    if(action.type == ADICIONAR_PESSOA_CORRETOR){
        dispatch(doLoad())
        database.ref('/usuarios').once('value', n =>{
            dispatch(finishLoad())
            let update = {};
            let {id, usuario, senha, nivel, telefones} = action;
            let _id = parseInt(n.val().length);
            update['/usuarios/'+ _id] = {id, usuario, senha, nivel, telefones};
            database.ref().update(update); 
        })
    }

    if(action.type == REMOVER_PESSOA_CORRETOR){
        dispatch(doLoad())
        database.ref('/usuarios').once('value', n =>{
            let update = {}
            update['/usuarios/'] = n.val();
            let tmpindex = update['/usuarios/'].findIndex(x => x.id==action.id)
            delete update['/usuarios/'][tmpindex];
            database.ref().update(update); 
            dispatch(finishLoad())
        })
    }

    if(action.type == EDITAR_INFORMACOES_CORRETOR){
        dispatch(doLoad())
        database.ref('/usuarios').once('value', n =>{
            let update = {}
            update['/usuarios/'] = n.val();
            let tmpindex = update['/usuarios/'].findIndex(x => x.id==action.id)
            update['/usuarios/'][tmpindex] = {...update['/usuarios/'][tmpindex], ...action.data};
            console.log('(action.type == EDITAR_INFORMACOES_CORRETOR)', update)
            database.ref().update(update); 
            dispatch(finishLoad())
        })
    }

    next(action);
}


// WEBPACK FOOTER //
// ./src/middlewares/corretores.js